import { ColorSchemePreferenceEnum } from '../../enums/ColorSchemePreferenceEnum';

/**
 * Query params appended when Filemanager opens / redirects to AIGrant or OfficeGrant.
 *
 * Contract (child apps read on boot; keeps existing refreshToken / aiGrant flows):
 * - `locale=en|es|it|tr` — Filemanager i18n codes (Office maps es/tr → en)
 * - `colorScheme=Light|Dark|System` — matches {@link ColorSchemePreferenceEnum}
 * - `highContrast=1` — omit when false
 * - `reduceMotion=1` — omit when false
 * - `refreshToken=<token>` — SSO handoff (AIGrant redirect; OfficeGrant `/open` beta)
 */
export interface AiGrantPreferencesQuery {
  locale?: string | null;
  colorSchemePreference: ColorSchemePreferenceEnum;
  highContrastEnabled?: boolean;
  reduceMotionEnabled?: boolean;
  refreshToken?: string | null;
}

/**
 * Append Filemanager UI prefs (and optional refreshToken) to an AIGrant / OfficeGrant URL.
 */
export function appendAiGrantPreferencesToUrl(
  baseUrl: string,
  preferences: AiGrantPreferencesQuery,
): string {
  const url = new URL(baseUrl);
  if (preferences.locale) {
    url.searchParams.set('locale', preferences.locale);
  } else {
    url.searchParams.delete('locale');
  }
  url.searchParams.set('colorScheme', preferences.colorSchemePreference);
  if (preferences.highContrastEnabled) {
    url.searchParams.set('highContrast', '1');
  } else {
    url.searchParams.delete('highContrast');
  }
  if (preferences.reduceMotionEnabled) {
    url.searchParams.set('reduceMotion', '1');
  } else {
    url.searchParams.delete('reduceMotion');
  }
  if (preferences.refreshToken) {
    url.searchParams.set('refreshToken', preferences.refreshToken);
  }
  return url.toString();
}
